import * as $runtime from "../runtime.js";
import * as Data$dDateTime from "../Data.DateTime/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTime$dDuration$dSerialized from "../Data.Time.Duration.Serialized/index.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Data$dUTCTime from "../Data.UTCTime/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dInternal$dStringify from "../Foreign.Internal.Stringify/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dAddresses$dTypes$dDeliveryAddress from "../Restaumatic.Addresses.Types.DeliveryAddress/index.js";
import * as Restaumatic$dCart$dProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic$dCurrencies from "../Restaumatic.Currencies/index.js";
import * as Restaumatic$dLocales from "../Restaumatic.Locales/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dCartToOrder from "../Restaumatic.Menu.V2.Types.CartToOrder/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dPackagingContainer from "../Restaumatic.Menu.V2.Types.PackagingContainer/index.js";
import * as Restaumatic$dOrders$dCheckout$dTypes$dExtraDiscount from "../Restaumatic.Orders.Checkout.Types.ExtraDiscount/index.js";
import * as Restaumatic$dOrders$dPayments$dTypes$dPaymentError from "../Restaumatic.Orders.Payments.Types.PaymentError/index.js";
import * as Restaumatic$dOrders$dTypes from "../Restaumatic.Orders.Types/index.js";
import * as Restaumatic$dOrders$dTypes$dFulfillmentMethod from "../Restaumatic.Orders.Types.FulfillmentMethod/index.js";
import * as Restaumatic$dOrders$dTypes$dOrderOrigin from "../Restaumatic.Orders.Types.OrderOrigin/index.js";
import * as Restaumatic$dOrders$dTypes$dPaymentMethod from "../Restaumatic.Orders.Types.PaymentMethod/index.js";
import * as Restaumatic$dPromotions$dTypes$dPromotionalItem from "../Restaumatic.Promotions.Types.PromotionalItem/index.js";
import * as Restaumatic$dValidation$dTypes from "../Restaumatic.Validation.Types/index.js";
import * as Restaumatic$dVatId from "../Restaumatic.VatId/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $CheckoutError = (tag, _1) => ({tag, _1});
const $FulfillmentMethod = (tag, _1) => ({tag, _1});
const $ItemError = (tag, _1) => ({tag, _1});
const ProductItem = x => x;
const OrderSplit = x => x;
const MenuItemDisabled = /* #__PURE__ */ $ItemError("MenuItemDisabled");
const InvalidQuantity = value0 => $ItemError("InvalidQuantity", value0);
const CustomProductsNotAvailable = /* #__PURE__ */ $ItemError("CustomProductsNotAvailable");
const FatalError = value0 => $ItemError("FatalError", value0);
const SoftError = value0 => $ItemError("SoftError", value0);
const Delivery = value0 => $FulfillmentMethod("Delivery", value0);
const Takeaway = /* #__PURE__ */ $FulfillmentMethod("Takeaway");
const DineIn = value0 => $FulfillmentMethod("DineIn", value0);
const NoContactDelivery = value0 => $FulfillmentMethod("NoContactDelivery", value0);
const Customer = x => x;
const CheckoutRequest = x => x;
const RestaurantDoesNotExist = /* #__PURE__ */ $CheckoutError("RestaurantDoesNotExist");
const AccountDoesNotExist = /* #__PURE__ */ $CheckoutError("AccountDoesNotExist");
const InvalidUserInSession = /* #__PURE__ */ $CheckoutError("InvalidUserInSession");
const OrderDoesNotExist = /* #__PURE__ */ $CheckoutError("OrderDoesNotExist");
const OrderNotEditable = /* #__PURE__ */ $CheckoutError("OrderNotEditable");
const RegisteredUserShouldLogIn = /* #__PURE__ */ $CheckoutError("RegisteredUserShouldLogIn");
const EmailNotProvidedAndNotLoggedIn = /* #__PURE__ */ $CheckoutError("EmailNotProvidedAndNotLoggedIn");
const InvalidEmail = /* #__PURE__ */ $CheckoutError("InvalidEmail");
const InvalidPhoneNumber = /* #__PURE__ */ $CheckoutError("InvalidPhoneNumber");
const QrWaiterDisabled = /* #__PURE__ */ $CheckoutError("QrWaiterDisabled");
const FulfillmentMethodNotSupported = /* #__PURE__ */ $CheckoutError("FulfillmentMethodNotSupported");
const PaymentMethodNotSupported = /* #__PURE__ */ $CheckoutError("PaymentMethodNotSupported");
const InvalidVatId = /* #__PURE__ */ $CheckoutError("InvalidVatId");
const LocaleNotEnabled = /* #__PURE__ */ $CheckoutError("LocaleNotEnabled");
const NotInDeliveryArea = /* #__PURE__ */ $CheckoutError("NotInDeliveryArea");
const CoordinatesNotProvided = /* #__PURE__ */ $CheckoutError("CoordinatesNotProvided");
const OrderValueTooLow = value0 => $CheckoutError("OrderValueTooLow", value0);
const OrderValueTooHigh = value0 => $CheckoutError("OrderValueTooHigh", value0);
const DelayedDeliveryNotEnabled = /* #__PURE__ */ $CheckoutError("DelayedDeliveryNotEnabled");
const RequestedDeliveryTimeTooShort = value0 => $CheckoutError("RequestedDeliveryTimeTooShort", value0);
const OutsideOfOrderingHours = /* #__PURE__ */ $CheckoutError("OutsideOfOrderingHours");
const DelayedDeliveryOutsideOfOrderingHours = /* #__PURE__ */ $CheckoutError("DelayedDeliveryOutsideOfOrderingHours");
const PromotionValidationErrors = value0 => $CheckoutError("PromotionValidationErrors", value0);
const InvalidCoupon = /* #__PURE__ */ $CheckoutError("InvalidCoupon");
const ItemError = value0 => $CheckoutError("ItemError", value0);
const FodAlreadyOrderedToAddress = /* #__PURE__ */ $CheckoutError("FodAlreadyOrderedToAddress");
const ExtraDiscountNotAllowed = /* #__PURE__ */ $CheckoutError("ExtraDiscountNotAllowed");
const ForbiddenOrigin = /* #__PURE__ */ $CheckoutError("ForbiddenOrigin");
const OriginNotProvided = /* #__PURE__ */ $CheckoutError("OriginNotProvided");
const PaymentError = value0 => $CheckoutError("PaymentError", value0);
const InvalidPackagingAssignment = /* #__PURE__ */ $CheckoutError("InvalidPackagingAssignment");
const SmsVerificationRequired = /* #__PURE__ */ $CheckoutError("SmsVerificationRequired");
const newtypeProductItem_ = {Coercible0: () => {}};
const newtypeOrderSplit_ = {Coercible0: () => {}};
const newtypeCustomer_ = {Coercible0: () => {}};
const newtypeCheckoutRequest_ = {Coercible0: () => {}};
const hasFieldProductItem = dictHasField => dictHasField;
const hasFieldOrderSplit = dictHasField => dictHasField;
const hasFieldCustomer = dictHasField => dictHasField;
const hasFieldCheckoutRequest = dictHasField => dictHasField;
const eqProductItem = {
  eq: x => y => (() => {
    if (x.note.tag === "Nothing") { return y.note.tag === "Nothing"; }
    if (x.note.tag === "Just") {
      if (y.note.tag === "Just") { return x.note._1 === y.note._1; }
      return false;
    }
    return false;
  })() && Restaumatic$dCart$dProductKey.eqProductKey.eq(x.productKey)(y.productKey) && x.quantity === y.quantity
};
const eqOrderSplit = {
  eq: x => y => Foreign$dInternal$dStringify.unsafeStringify(x.draft) === Foreign$dInternal$dStringify.unsafeStringify(y.draft) && Data$dEq.eqArrayImpl(eqProductItem.eq)(x.items)(y.items)
};
const eqItemError = {
  eq: x => y => {
    if (x.tag === "MenuItemDisabled") { return y.tag === "MenuItemDisabled"; }
    if (x.tag === "InvalidQuantity") {
      if (y.tag === "InvalidQuantity") { return x._1.requestedQuantity === y._1.requestedQuantity; }
      return false;
    }
    if (x.tag === "CustomProductsNotAvailable") { return y.tag === "CustomProductsNotAvailable"; }
    if (x.tag === "FatalError") {
      if (y.tag === "FatalError") { return Restaumatic$dMenu$dV2$dTypes$dCartToOrder.eqFatalError.eq(x._1)(y._1); }
      return false;
    }
    if (x.tag === "SoftError") {
      if (y.tag === "SoftError") { return Restaumatic$dMenu$dV2$dTypes$dCartToOrder.eqSoftError.eq(x._1)(y._1); }
      return false;
    }
    return false;
  }
};
const eqFulfillmentMethod = {
  eq: x => y => {
    if (x.tag === "Delivery") {
      if (y.tag === "Delivery") {
        return (() => {
          if (x._1.customDeliveryPrice.tag === "Nothing") { return y._1.customDeliveryPrice.tag === "Nothing"; }
          if (x._1.customDeliveryPrice.tag === "Just") {
            if (y._1.customDeliveryPrice.tag === "Just") { return x._1.customDeliveryPrice._1 === y._1.customDeliveryPrice._1; }
            return false;
          }
          return false;
        })() && Restaumatic$dAddresses$dTypes$dDeliveryAddress.eqDeliveryAddress.eq(x._1.deliveryAddress)(y._1.deliveryAddress);
      }
      return false;
    }
    if (x.tag === "Takeaway") { return y.tag === "Takeaway"; }
    if (x.tag === "DineIn") {
      if (y.tag === "DineIn") {
        if (x._1.location.tag === "Nothing") { return y._1.location.tag === "Nothing"; }
        if (x._1.location.tag === "Just") {
          if (y._1.location.tag === "Just") { return x._1.location._1.number === y._1.location._1.number; }
          return false;
        }
        return false;
      }
      return false;
    }
    if (x.tag === "NoContactDelivery") {
      if (y.tag === "NoContactDelivery") { return Restaumatic$dAddresses$dTypes$dDeliveryAddress.eqDeliveryAddress.eq(x._1.deliveryAddress)(y._1.deliveryAddress); }
      return false;
    }
    return false;
  }
};
const eqCustomer = {
  eq: x => y => (() => {
    if (x.email.tag === "Nothing") { return y.email.tag === "Nothing"; }
    if (x.email.tag === "Just") {
      if (y.email.tag === "Just") { return x.email._1 === y.email._1; }
      return false;
    }
    return false;
  })() && x.fullName === y.fullName && (() => {
    if (x.phone.tag === "Nothing") { return y.phone.tag === "Nothing"; }
    if (x.phone.tag === "Just") {
      if (y.phone.tag === "Just") { return x.phone._1 === y.phone._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.subscribeEmail.tag === "Nothing") { return y.subscribeEmail.tag === "Nothing"; }
    if (x.subscribeEmail.tag === "Just") {
      if (y.subscribeEmail.tag === "Just") { return x.subscribeEmail._1 === y.subscribeEmail._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.subscribePhone.tag === "Nothing") { return y.subscribePhone.tag === "Nothing"; }
    if (x.subscribePhone.tag === "Just") {
      if (y.subscribePhone.tag === "Just") { return x.subscribePhone._1 === y.subscribePhone._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.subscribeRestaumaticEmail.tag === "Nothing") { return y.subscribeRestaumaticEmail.tag === "Nothing"; }
    if (x.subscribeRestaumaticEmail.tag === "Just") {
      if (y.subscribeRestaumaticEmail.tag === "Just") { return x.subscribeRestaumaticEmail._1 === y.subscribeRestaumaticEmail._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.subscribeRestaumaticPhone.tag === "Nothing") { return y.subscribeRestaumaticPhone.tag === "Nothing"; }
    if (x.subscribeRestaumaticPhone.tag === "Just") {
      if (y.subscribeRestaumaticPhone.tag === "Just") { return x.subscribeRestaumaticPhone._1 === y.subscribeRestaumaticPhone._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.subscribed.tag === "Nothing") { return y.subscribed.tag === "Nothing"; }
    if (x.subscribed.tag === "Just") {
      if (y.subscribed.tag === "Just") { return x.subscribed._1 === y.subscribed._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.subscribedRestaumatic.tag === "Nothing") { return y.subscribedRestaumatic.tag === "Nothing"; }
    if (x.subscribedRestaumatic.tag === "Just") {
      if (y.subscribedRestaumatic.tag === "Just") { return x.subscribedRestaumatic._1 === y.subscribedRestaumatic._1; }
      return false;
    }
    return false;
  })()
};
const eqCheckoutRequest = {
  eq: x => y => Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl)(x.couponCodes)(y.couponCodes) && eqCustomer.eq(x.customer)(y.customer) && (() => {
    if (x.draft.tag === "Nothing") { return y.draft.tag === "Nothing"; }
    if (x.draft.tag === "Just") {
      if (y.draft.tag === "Just") { return Foreign$dInternal$dStringify.unsafeStringify(x.draft._1) === Foreign$dInternal$dStringify.unsafeStringify(y.draft._1); }
      return false;
    }
    return false;
  })() && (() => {
    if (x.extraDiscount.tag === "Nothing") { return y.extraDiscount.tag === "Nothing"; }
    if (x.extraDiscount.tag === "Just") {
      if (y.extraDiscount.tag === "Just") {
        return x.extraDiscount._1.name === y.extraDiscount._1.name && (() => {
          if (x.extraDiscount._1.prize.tag === "PriceDiscount") {
            if (y.extraDiscount._1.prize.tag === "PriceDiscount") { return x.extraDiscount._1.prize._1 === y.extraDiscount._1.prize._1; }
            return false;
          }
          if (x.extraDiscount._1.prize.tag === "PercentageDiscount") {
            if (y.extraDiscount._1.prize.tag === "PercentageDiscount") { return x.extraDiscount._1.prize._1 === y.extraDiscount._1.prize._1; }
            return false;
          }
          return false;
        })();
      }
      return false;
    }
    return false;
  })() && eqFulfillmentMethod.eq(x.fulfillmentMethod)(y.fulfillmentMethod) && Data$dEq.eqArrayImpl(eqProductItem.eq)(x.items)(y.items) && (() => {
    if (x.locale.tag === "PL") { return y.locale.tag === "PL"; }
    if (x.locale.tag === "EN") { return y.locale.tag === "EN"; }
    if (x.locale.tag === "EN_GB") { return y.locale.tag === "EN_GB"; }
    if (x.locale.tag === "RO") { return y.locale.tag === "RO"; }
    if (x.locale.tag === "RU") { return y.locale.tag === "RU"; }
    if (x.locale.tag === "CS") { return y.locale.tag === "CS"; }
    if (x.locale.tag === "SK") { return y.locale.tag === "SK"; }
    if (x.locale.tag === "HR") { return y.locale.tag === "HR"; }
    if (x.locale.tag === "DE") { return y.locale.tag === "DE"; }
    if (x.locale.tag === "NL") { return y.locale.tag === "NL"; }
    if (x.locale.tag === "ES") { return y.locale.tag === "ES"; }
    if (x.locale.tag === "IT") { return y.locale.tag === "IT"; }
    if (x.locale.tag === "UK") { return y.locale.tag === "UK"; }
    if (x.locale.tag === "PT_BR") { return y.locale.tag === "PT_BR"; }
    return false;
  })() && (() => {
    if (x.origin.tag === "Nothing") { return y.origin.tag === "Nothing"; }
    if (x.origin.tag === "Just") {
      if (y.origin.tag === "Just") { return Restaumatic$dOrders$dTypes$dOrderOrigin.eqOrderOrigin.eq(x.origin._1)(y.origin._1); }
      return false;
    }
    return false;
  })() && (() => {
    const $0 = Data$dEq.eqArrayImpl((() => {
      const $0 = Data$dEq.eqArrayImpl(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.eqContainedId.eq);
      return x$1 => y$1 => x$1._1 === y$1._1 && $0(x$1._2)(y$1._2);
    })());
    if (x.packagingContainers.tag === "Nothing") { return y.packagingContainers.tag === "Nothing"; }
    if (x.packagingContainers.tag === "Just") {
      if (y.packagingContainers.tag === "Just") { return $0(x.packagingContainers._1)(y.packagingContainers._1); }
      return false;
    }
    return false;
  })() && (() => {
    if (x.paymentMethod.tag === "Cash") { return y.paymentMethod.tag === "Cash"; }
    if (x.paymentMethod.tag === "Online") { return y.paymentMethod.tag === "Online"; }
    if (x.paymentMethod.tag === "Card") { return y.paymentMethod.tag === "Card"; }
    if (x.paymentMethod.tag === "Prepaid") { return y.paymentMethod.tag === "Prepaid"; }
    if (x.paymentMethod.tag === "Offline") { return y.paymentMethod.tag === "Offline"; }
    if (x.paymentMethod.tag === "CashAndCard") { return y.paymentMethod.tag === "CashAndCard"; }
    if (x.paymentMethod.tag === "BankTransfer") { return y.paymentMethod.tag === "BankTransfer"; }
    return false;
  })() && Data$dEq.eqArrayImpl(Restaumatic$dPromotions$dTypes$dPromotionalItem.eqPromotionalItem.eq)(x.promotionalItems)(y.promotionalItems) && (() => {
    if (x.requestedFulfillmentTime.tag === "Nothing") { return y.requestedFulfillmentTime.tag === "Nothing"; }
    if (x.requestedFulfillmentTime.tag === "Just") {
      if (y.requestedFulfillmentTime.tag === "Just") { return Data$dDateTime.eqDateTime.eq(x.requestedFulfillmentTime._1)(y.requestedFulfillmentTime._1); }
      return false;
    }
    return false;
  })() && x.restaurantId === y.restaurantId && (() => {
    if (x.userNote.tag === "Nothing") { return y.userNote.tag === "Nothing"; }
    if (x.userNote.tag === "Just") {
      if (y.userNote.tag === "Just") { return x.userNote._1 === y.userNote._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.vatId.tag === "Nothing") { return y.vatId.tag === "Nothing"; }
    if (x.vatId.tag === "Just") {
      if (y.vatId.tag === "Just") { return x.vatId._1 === y.vatId._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.waiterPin.tag === "Nothing") { return y.waiterPin.tag === "Nothing"; }
    if (x.waiterPin.tag === "Just") {
      if (y.waiterPin.tag === "Just") { return x.waiterPin._1 === y.waiterPin._1; }
      return false;
    }
    return false;
  })()
};
const eqCheckoutError = {
  eq: x => y => {
    if (x.tag === "RestaurantDoesNotExist") { return y.tag === "RestaurantDoesNotExist"; }
    if (x.tag === "AccountDoesNotExist") { return y.tag === "AccountDoesNotExist"; }
    if (x.tag === "InvalidUserInSession") { return y.tag === "InvalidUserInSession"; }
    if (x.tag === "OrderDoesNotExist") { return y.tag === "OrderDoesNotExist"; }
    if (x.tag === "OrderNotEditable") { return y.tag === "OrderNotEditable"; }
    if (x.tag === "RegisteredUserShouldLogIn") { return y.tag === "RegisteredUserShouldLogIn"; }
    if (x.tag === "EmailNotProvidedAndNotLoggedIn") { return y.tag === "EmailNotProvidedAndNotLoggedIn"; }
    if (x.tag === "InvalidEmail") { return y.tag === "InvalidEmail"; }
    if (x.tag === "InvalidPhoneNumber") { return y.tag === "InvalidPhoneNumber"; }
    if (x.tag === "QrWaiterDisabled") { return y.tag === "QrWaiterDisabled"; }
    if (x.tag === "FulfillmentMethodNotSupported") { return y.tag === "FulfillmentMethodNotSupported"; }
    if (x.tag === "PaymentMethodNotSupported") { return y.tag === "PaymentMethodNotSupported"; }
    if (x.tag === "InvalidVatId") { return y.tag === "InvalidVatId"; }
    if (x.tag === "LocaleNotEnabled") { return y.tag === "LocaleNotEnabled"; }
    if (x.tag === "NotInDeliveryArea") { return y.tag === "NotInDeliveryArea"; }
    if (x.tag === "CoordinatesNotProvided") { return y.tag === "CoordinatesNotProvided"; }
    if (x.tag === "OrderValueTooLow") {
      if (y.tag === "OrderValueTooLow") {
        return x._1.actualValue === y._1.actualValue && (() => {
          if (x._1.currency.tag === "PLN") { return y._1.currency.tag === "PLN"; }
          if (x._1.currency.tag === "GBP") { return y._1.currency.tag === "GBP"; }
          if (x._1.currency.tag === "USD") { return y._1.currency.tag === "USD"; }
          if (x._1.currency.tag === "EUR") { return y._1.currency.tag === "EUR"; }
          if (x._1.currency.tag === "RUB") { return y._1.currency.tag === "RUB"; }
          if (x._1.currency.tag === "RON") { return y._1.currency.tag === "RON"; }
          if (x._1.currency.tag === "CZK") { return y._1.currency.tag === "CZK"; }
          if (x._1.currency.tag === "HRK") { return y._1.currency.tag === "HRK"; }
          if (x._1.currency.tag === "BRL") { return y._1.currency.tag === "BRL"; }
          return false;
        })() && x._1.limit === y._1.limit;
      }
      return false;
    }
    if (x.tag === "OrderValueTooHigh") {
      if (y.tag === "OrderValueTooHigh") {
        return x._1.actualValue === y._1.actualValue && (() => {
          if (x._1.currency.tag === "PLN") { return y._1.currency.tag === "PLN"; }
          if (x._1.currency.tag === "GBP") { return y._1.currency.tag === "GBP"; }
          if (x._1.currency.tag === "USD") { return y._1.currency.tag === "USD"; }
          if (x._1.currency.tag === "EUR") { return y._1.currency.tag === "EUR"; }
          if (x._1.currency.tag === "RUB") { return y._1.currency.tag === "RUB"; }
          if (x._1.currency.tag === "RON") { return y._1.currency.tag === "RON"; }
          if (x._1.currency.tag === "CZK") { return y._1.currency.tag === "CZK"; }
          if (x._1.currency.tag === "HRK") { return y._1.currency.tag === "HRK"; }
          if (x._1.currency.tag === "BRL") { return y._1.currency.tag === "BRL"; }
          return false;
        })() && x._1.limit === y._1.limit;
      }
      return false;
    }
    if (x.tag === "DelayedDeliveryNotEnabled") { return y.tag === "DelayedDeliveryNotEnabled"; }
    if (x.tag === "RequestedDeliveryTimeTooShort") {
      if (y.tag === "RequestedDeliveryTimeTooShort") { return x._1.difference === y._1.difference; }
      return false;
    }
    if (x.tag === "OutsideOfOrderingHours") { return y.tag === "OutsideOfOrderingHours"; }
    if (x.tag === "DelayedDeliveryOutsideOfOrderingHours") { return y.tag === "DelayedDeliveryOutsideOfOrderingHours"; }
    if (x.tag === "PromotionValidationErrors") {
      if (y.tag === "PromotionValidationErrors") { return Data$dEq.eqArrayImpl(Restaumatic$dValidation$dTypes.eqError.eq)(x._1)(y._1); }
      return false;
    }
    if (x.tag === "InvalidCoupon") { return y.tag === "InvalidCoupon"; }
    if (x.tag === "ItemError") {
      if (y.tag === "ItemError") {
        return x._1.groupIndex === y._1.groupIndex && eqItemError.eq(x._1.itemError)(y._1.itemError) && (() => {
          if (x._1.name.tag === "Nothing") { return y._1.name.tag === "Nothing"; }
          if (x._1.name.tag === "Just") {
            if (y._1.name.tag === "Just") { return x._1.name._1 === y._1.name._1; }
            return false;
          }
          return false;
        })();
      }
      return false;
    }
    if (x.tag === "FodAlreadyOrderedToAddress") { return y.tag === "FodAlreadyOrderedToAddress"; }
    if (x.tag === "ExtraDiscountNotAllowed") { return y.tag === "ExtraDiscountNotAllowed"; }
    if (x.tag === "ForbiddenOrigin") { return y.tag === "ForbiddenOrigin"; }
    if (x.tag === "OriginNotProvided") { return y.tag === "OriginNotProvided"; }
    if (x.tag === "PaymentError") {
      if (y.tag === "PaymentError") {
        if (x._1.tag === "InvalidBlikCode") { return y._1.tag === "InvalidBlikCode"; }
        if (x._1.tag === "CardProcessingError") { return y._1.tag === "CardProcessingError"; }
        if (x._1.tag === "OtherError") {
          if (y._1.tag === "OtherError") { return x._1._1 === y._1._1; }
          return false;
        }
        return false;
      }
      return false;
    }
    if (x.tag === "InvalidPackagingAssignment") { return y.tag === "InvalidPackagingAssignment"; }
    if (x.tag === "SmsVerificationRequired") { return y.tag === "SmsVerificationRequired"; }
    return false;
  }
};
const genericProductItem = {to: x => x, from: x => x};
const showProductItem = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")([
            "note",
            (() => {
              if (v.note.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.note._1) + ")"; }
              if (v.note.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["productKey", Restaumatic$dCart$dProductKey.showProductKey.show(v.productKey)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "quantity",
            Data$dShow.showIntImpl(v.quantity)
          ]))([])));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "ProductItem"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeProductItem = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "note"})(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "productKey"
    })(Restaumatic$dCart$dProductKey.unscrambleDecodeProductKey)(Unscramble.decodeRecordCons({reflectSymbol: () => "quantity"})(Unscramble.decodeInt1)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericOrderSplit = {to: x => x, from: x => x};
const showOrderSplit = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(showProductItem.show);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["draft", Restaumatic$dOrders$dTypes.showOrderDraft.show(v.draft)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "items",
              $0(v.items)
            ]))([]));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "OrderSplit"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeOrderSplit = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "draft"})(Restaumatic$dOrders$dTypes.unscrambleDecodeOrderDraft)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "items"
    })({unsafeDecode: Unscramble.decodeArray(unscrambleDecodeProductItem.unsafeDecode)})(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericItemError = {
  to: x => {
    if (x.tag === "Inl") { return MenuItemDisabled; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $ItemError("InvalidQuantity", x._1._1); }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return CustomProductsNotAvailable; }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return $ItemError("FatalError", x._1._1._1._1); }
          if (x._1._1._1.tag === "Inr") { return $ItemError("SoftError", x._1._1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "MenuItemDisabled") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "InvalidQuantity") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "CustomProductsNotAvailable") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)));
    }
    if (x.tag === "FatalError") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))); }
    if (x.tag === "SoftError") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1)))); }
    $runtime.fail();
  }
};
const showItemError = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "MenuItemDisabled"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["requestedQuantity", Data$dShow.showIntImpl(v.requestedQuantity)]))([]);
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "InvalidQuantity"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "CustomProductsNotAvailable"});
    const $3 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dMenu$dV2$dTypes$dCartToOrder.showFatalError.show(v)]})({
      reflectSymbol: () => "FatalError"
    });
    const $4 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dMenu$dV2$dTypes$dCartToOrder.showSoftError.show(v)]})({
      reflectSymbol: () => "SoftError"
    });
    return x => {
      const $5 = genericItemError.from(x);
      if ($5.tag === "Inl") { return $0["genericShow'"]($5._1); }
      if ($5.tag === "Inr") {
        if ($5._1.tag === "Inl") { return $1["genericShow'"]($5._1._1); }
        if ($5._1.tag === "Inr") {
          if ($5._1._1.tag === "Inl") { return $2["genericShow'"]($5._1._1._1); }
          if ($5._1._1.tag === "Inr") {
            if ($5._1._1._1.tag === "Inl") { return $3["genericShow'"]($5._1._1._1._1); }
            if ($5._1._1._1.tag === "Inr") { return $4["genericShow'"]($5._1._1._1._1); }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeItemError = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "MenuItemDisabled"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "InvalidQuantity"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "requestedQuantity"})(Unscramble.decodeInt1)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "CustomProductsNotAvailable"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "FatalError"})({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dCartToOrder.unscrambleDecodeFatalError.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "SoftError"})({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dCartToOrder.unscrambleDecodeSoftError.unsafeDecode(x.contents)
    }))))))(Unscramble$dGeneric.defaultOptions);
    return x => genericItemError.to($0(x));
  })()
};
const genericFulfillmentMethod = {
  to: x => {
    if (x.tag === "Inl") { return $FulfillmentMethod("Delivery", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return Takeaway; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return $FulfillmentMethod("DineIn", x._1._1._1); }
        if (x._1._1.tag === "Inr") { return $FulfillmentMethod("NoContactDelivery", x._1._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Delivery") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "Takeaway") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "DineIn") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))); }
    if (x.tag === "NoContactDelivery") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1))); }
    $runtime.fail();
  }
};
const showFulfillmentMethod = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")([
            "customDeliveryPrice",
            (() => {
              if (v.customDeliveryPrice.tag === "Just") { return "(Just " + Data$dMoney$dRounded.toString(v.customDeliveryPrice._1) + ")"; }
              if (v.customDeliveryPrice.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["deliveryAddress", Restaumatic$dAddresses$dTypes$dDeliveryAddress.showDeliveryAddress.show(v.deliveryAddress)]))([]));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "Delivery"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Takeaway"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")([
            "location",
            (() => {
              if (v.location.tag === "Just") { return "(Just " + Restaumatic$dOrders$dTypes$dFulfillmentMethod.showDineInLocation.show(v.location._1) + ")"; }
              if (v.location.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))([]);
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "DineIn"});
    const $3 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["deliveryAddress", Restaumatic$dAddresses$dTypes$dDeliveryAddress.showDeliveryAddress.show(v.deliveryAddress)]))([]);
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "NoContactDelivery"});
    return x => {
      const $4 = genericFulfillmentMethod.from(x);
      if ($4.tag === "Inl") { return $0["genericShow'"]($4._1); }
      if ($4.tag === "Inr") {
        if ($4._1.tag === "Inl") { return $1["genericShow'"]($4._1._1); }
        if ($4._1.tag === "Inr") {
          if ($4._1._1.tag === "Inl") { return $2["genericShow'"]($4._1._1._1); }
          if ($4._1._1.tag === "Inr") { return $3["genericShow'"]($4._1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeFulfillmentMethod = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "Delivery"
    })({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "customDeliveryPrice"})(Unscramble.decodeMaybe(Data$dMoney$dRounded.udecodeMoney))(Unscramble.decodeRecordCons({
        reflectSymbol: () => "deliveryAddress"
      })(Restaumatic$dAddresses$dTypes$dDeliveryAddress.unscrambleDecodeDeliveryAddress)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({reflectSymbol: () => "Takeaway"}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "DineIn"
    })({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "location"})(Unscramble.decodeMaybe(Restaumatic$dOrders$dTypes$dFulfillmentMethod.unscrambleDecodeDineInLocation))(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "NoContactDelivery"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "deliveryAddress"})(Restaumatic$dAddresses$dTypes$dDeliveryAddress.unscrambleDecodeDeliveryAddress)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    })))))(Unscramble$dGeneric.defaultOptions);
    return x => genericFulfillmentMethod.to($0(x));
  })()
};
const genericCustomer = {to: x => x, from: x => x};
const showCustomer = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")([
            "email",
            (() => {
              if (v.email.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.email._1) + ")"; }
              if (v.email.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["fullName", Data$dShow.showStringImpl(v.fullName)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "phone",
            (() => {
              if (v.phone.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.phone._1) + ")"; }
              if (v.phone.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "subscribeEmail",
            (() => {
              if (v.subscribeEmail.tag === "Just") {
                if (v.subscribeEmail._1) { return "(Just true)"; }
                return "(Just false)";
              }
              if (v.subscribeEmail.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "subscribePhone",
            (() => {
              if (v.subscribePhone.tag === "Just") {
                if (v.subscribePhone._1) { return "(Just true)"; }
                return "(Just false)";
              }
              if (v.subscribePhone.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "subscribeRestaumaticEmail",
            (() => {
              if (v.subscribeRestaumaticEmail.tag === "Just") {
                if (v.subscribeRestaumaticEmail._1) { return "(Just true)"; }
                return "(Just false)";
              }
              if (v.subscribeRestaumaticEmail.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "subscribeRestaumaticPhone",
            (() => {
              if (v.subscribeRestaumaticPhone.tag === "Just") {
                if (v.subscribeRestaumaticPhone._1) { return "(Just true)"; }
                return "(Just false)";
              }
              if (v.subscribeRestaumaticPhone.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "subscribed",
            (() => {
              if (v.subscribed.tag === "Just") {
                if (v.subscribed._1) { return "(Just true)"; }
                return "(Just false)";
              }
              if (v.subscribed.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "subscribedRestaumatic",
            (() => {
              if (v.subscribedRestaumatic.tag === "Just") {
                if (v.subscribedRestaumatic._1) { return "(Just true)"; }
                return "(Just false)";
              }
              if (v.subscribedRestaumatic.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))([])))))))));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "Customer"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCustomer = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "email"})(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "fullName"
    })(Unscramble.decodeString1)(Unscramble.decodeRecordCons({reflectSymbol: () => "phone"})(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "subscribeEmail"
    })(Unscramble.decodeMaybe(Unscramble.decodeBoolean1))(Unscramble.decodeRecordCons({reflectSymbol: () => "subscribePhone"})(Unscramble.decodeMaybe(Unscramble.decodeBoolean1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "subscribeRestaumaticEmail"
    })(Unscramble.decodeMaybe(Unscramble.decodeBoolean1))(Unscramble.decodeRecordCons({reflectSymbol: () => "subscribeRestaumaticPhone"})(Unscramble.decodeMaybe(Unscramble.decodeBoolean1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "subscribed"
    })(Unscramble.decodeMaybe(Unscramble.decodeBoolean1))(Unscramble.decodeRecordCons({reflectSymbol: () => "subscribedRestaumatic"})(Unscramble.decodeMaybe(Unscramble.decodeBoolean1))(Unscramble.decodeRecordNil))))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericCheckoutRequest = {to: x => x, from: x => x};
const showCheckoutRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Restaumatic$dPromotions$dTypes$dPromotionalItem.showPromotionalItem.show);
      const $1 = Data$dShow.showArrayImpl(Data$dTuple$dT2.showT2(Data$dUUID.showUUID)({
        show: Data$dShow.showArrayImpl(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.showContainedId.show)
      }).show);
      const $2 = Data$dShow.showArrayImpl(showProductItem.show);
      const $3 = Data$dShow.showArrayImpl(Data$dShow.showStringImpl);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["couponCodes", $3(v.couponCodes)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "customer",
              showCustomer.show(v.customer)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "draft",
              (() => {
                if (v.draft.tag === "Just") { return "(Just " + Restaumatic$dOrders$dTypes.showOrderDraft.show(v.draft._1) + ")"; }
                if (v.draft.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "extraDiscount",
              (() => {
                if (v.extraDiscount.tag === "Just") { return "(Just " + Restaumatic$dOrders$dCheckout$dTypes$dExtraDiscount.showExtraDiscount.show(v.extraDiscount._1) + ")"; }
                if (v.extraDiscount.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["fulfillmentMethod", showFulfillmentMethod.show(v.fulfillmentMethod)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "items",
              $2(v.items)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["locale", Restaumatic$dLocales.showLocale.show(v.locale)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "origin",
              (() => {
                if (v.origin.tag === "Just") { return "(Just " + Restaumatic$dOrders$dTypes$dOrderOrigin.showOrderOrigin.show(v.origin._1) + ")"; }
                if (v.origin.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "packagingContainers",
              (() => {
                if (v.packagingContainers.tag === "Just") { return "(Just " + $1(v.packagingContainers._1) + ")"; }
                if (v.packagingContainers.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["paymentMethod", Restaumatic$dOrders$dTypes$dPaymentMethod.showPaymentMethod.show(v.paymentMethod)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "promotionalItems",
              $0(v.promotionalItems)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "requestedFulfillmentTime",
              (() => {
                if (v.requestedFulfillmentTime.tag === "Just") { return "(Just " + DateUtils.formatISODateTime(v.requestedFulfillmentTime._1) + ")"; }
                if (v.requestedFulfillmentTime.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["restaurantId", Data$dShow.showIntImpl(v.restaurantId)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "userNote",
              (() => {
                if (v.userNote.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.userNote._1) + ")"; }
                if (v.userNote.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "vatId",
              (() => {
                if (v.vatId.tag === "Just") { return "(Just " + Restaumatic$dVatId.showVatId.show(v.vatId._1) + ")"; }
                if (v.vatId.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "waiterPin",
              (() => {
                if (v.waiterPin.tag === "Just") { return "(Just " + Data$dShow.showIntImpl(v.waiterPin._1) + ")"; }
                if (v.waiterPin.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))([]))))))))))))))));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "CheckoutRequest"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCheckoutRequest = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "couponCodes"})({unsafeDecode: Unscramble.decodeArray(Unscramble.decodeString)})(Unscramble.decodeRecordCons({
      reflectSymbol: () => "customer"
    })(unscrambleDecodeCustomer)(Unscramble.decodeRecordCons({reflectSymbol: () => "draft"})(Unscramble.decodeMaybe(Restaumatic$dOrders$dTypes.unscrambleDecodeOrderDraft))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "extraDiscount"
    })(Unscramble.decodeMaybe(Restaumatic$dOrders$dCheckout$dTypes$dExtraDiscount.unscrambleDecodeExtraDiscount))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "fulfillmentMethod"
    })(unscrambleDecodeFulfillmentMethod)(Unscramble.decodeRecordCons({reflectSymbol: () => "items"})({
      unsafeDecode: Unscramble.decodeArray(unscrambleDecodeProductItem.unsafeDecode)
    })(Unscramble.decodeRecordCons({reflectSymbol: () => "locale"})(Restaumatic$dLocales.udecodeLocale)(Unscramble.decodeRecordCons({reflectSymbol: () => "origin"})(Unscramble.decodeMaybe(Restaumatic$dOrders$dTypes$dOrderOrigin.unscrambleDecodeOrderOrigin))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "packagingContainers"
    })(Unscramble.decodeMaybe({
      unsafeDecode: Unscramble.decodeArray(Data$dTuple$dT2.udecodeT2(Data$dUUID.udecodeUUID)({
        unsafeDecode: Unscramble.decodeArray(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.unscrambleDecodeContainedId.unsafeDecode)
      }).unsafeDecode)
    }))(Unscramble.decodeRecordCons({reflectSymbol: () => "paymentMethod"})(Restaumatic$dOrders$dTypes$dPaymentMethod.unscrambleDecodePaymentMethod)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "promotionalItems"
    })({unsafeDecode: Unscramble.decodeArray(Restaumatic$dPromotions$dTypes$dPromotionalItem.unscrambleDecodePromotionalItem.unsafeDecode)})(Unscramble.decodeRecordCons({
      reflectSymbol: () => "requestedFulfillmentTime"
    })(Unscramble.decodeMaybe(Data$dUTCTime.unscrambleDecodeUTCTime))(Unscramble.decodeRecordCons({reflectSymbol: () => "restaurantId"})(Unscramble.decodeInt1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "userNote"
    })(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({reflectSymbol: () => "vatId"})(Unscramble.decodeMaybe(Restaumatic$dVatId.unscrambleDecodeVatId))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "waiterPin"
    })(Unscramble.decodeMaybe(Unscramble.decodeInt1))(Unscramble.decodeRecordNil)))))))))))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericCheckoutError = {
  to: x => {
    if (x.tag === "Inl") { return RestaurantDoesNotExist; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return AccountDoesNotExist; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return InvalidUserInSession; }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return OrderDoesNotExist; }
          if (x._1._1._1.tag === "Inr") {
            if (x._1._1._1._1.tag === "Inl") { return OrderNotEditable; }
            if (x._1._1._1._1.tag === "Inr") {
              if (x._1._1._1._1._1.tag === "Inl") { return RegisteredUserShouldLogIn; }
              if (x._1._1._1._1._1.tag === "Inr") {
                if (x._1._1._1._1._1._1.tag === "Inl") { return EmailNotProvidedAndNotLoggedIn; }
                if (x._1._1._1._1._1._1.tag === "Inr") {
                  if (x._1._1._1._1._1._1._1.tag === "Inl") { return InvalidEmail; }
                  if (x._1._1._1._1._1._1._1.tag === "Inr") {
                    if (x._1._1._1._1._1._1._1._1.tag === "Inl") { return InvalidPhoneNumber; }
                    if (x._1._1._1._1._1._1._1._1.tag === "Inr") {
                      if (x._1._1._1._1._1._1._1._1._1.tag === "Inl") { return QrWaiterDisabled; }
                      if (x._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                        if (x._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return FulfillmentMethodNotSupported; }
                        if (x._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if (x._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return PaymentMethodNotSupported; }
                          if (x._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                            if (x._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return InvalidVatId; }
                            if (x._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                              if (x._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return LocaleNotEnabled; }
                              if (x._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return NotInDeliveryArea; }
                                if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                  if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return CoordinatesNotProvided; }
                                  if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                    if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                      return $CheckoutError("OrderValueTooLow", x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                    }
                                    if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                      if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                        return $CheckoutError("OrderValueTooHigh", x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                      }
                                      if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                        if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return DelayedDeliveryNotEnabled; }
                                        if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                          if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                            return $CheckoutError("RequestedDeliveryTimeTooShort", x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                          }
                                          if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                            if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return OutsideOfOrderingHours; }
                                            if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                              if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return DelayedDeliveryOutsideOfOrderingHours; }
                                              if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                  return $CheckoutError("PromotionValidationErrors", x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                }
                                                if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                  if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return InvalidCoupon; }
                                                  if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                    if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                      return $CheckoutError("ItemError", x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                    }
                                                    if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                      if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                        return FodAlreadyOrderedToAddress;
                                                      }
                                                      if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                        if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                          return ExtraDiscountNotAllowed;
                                                        }
                                                        if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                          if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                            return ForbiddenOrigin;
                                                          }
                                                          if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                            if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                              return OriginNotProvided;
                                                            }
                                                            if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                              if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                                return $CheckoutError(
                                                                  "PaymentError",
                                                                  x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1
                                                                );
                                                              }
                                                              if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                                  return InvalidPackagingAssignment;
                                                                }
                                                                if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                  return SmsVerificationRequired;
                                                                }
                                                                $runtime.fail();
                                                              }
                                                              $runtime.fail();
                                                            }
                                                            $runtime.fail();
                                                          }
                                                          $runtime.fail();
                                                        }
                                                        $runtime.fail();
                                                      }
                                                      $runtime.fail();
                                                    }
                                                    $runtime.fail();
                                                  }
                                                  $runtime.fail();
                                                }
                                                $runtime.fail();
                                              }
                                              $runtime.fail();
                                            }
                                            $runtime.fail();
                                          }
                                          $runtime.fail();
                                        }
                                        $runtime.fail();
                                      }
                                      $runtime.fail();
                                    }
                                    $runtime.fail();
                                  }
                                  $runtime.fail();
                                }
                                $runtime.fail();
                              }
                              $runtime.fail();
                            }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "RestaurantDoesNotExist") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "AccountDoesNotExist") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "InvalidUserInSession") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "OrderDoesNotExist") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x.tag === "OrderNotEditable") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
      );
    }
    if (x.tag === "RegisteredUserShouldLogIn") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
        )
      );
    }
    if (x.tag === "EmailNotProvidedAndNotLoggedIn") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
          )
        )
      );
    }
    if (x.tag === "InvalidEmail") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
            )
          )
        )
      );
    }
    if (x.tag === "InvalidPhoneNumber") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
              )
            )
          )
        )
      );
    }
    if (x.tag === "QrWaiterDisabled") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "FulfillmentMethodNotSupported") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "PaymentMethodNotSupported") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "InvalidVatId") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "LocaleNotEnabled") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "NotInDeliveryArea") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "CoordinatesNotProvided") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "OrderValueTooLow") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))))
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "OrderValueTooHigh") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))))
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "DelayedDeliveryNotEnabled") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "RequestedDeliveryTimeTooShort") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))))
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "OutsideOfOrderingHours") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "DelayedDeliveryOutsideOfOrderingHours") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "PromotionValidationErrors") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))))
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "InvalidCoupon") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum(
                                                "Inr",
                                                Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "ItemError") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum(
                                                "Inr",
                                                Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))))
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "FodAlreadyOrderedToAddress") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum(
                                                "Inr",
                                                Data$dGeneric$dRep.$Sum(
                                                  "Inr",
                                                  Data$dGeneric$dRep.$Sum(
                                                    "Inr",
                                                    Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                                                  )
                                                )
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "ExtraDiscountNotAllowed") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum(
                                                "Inr",
                                                Data$dGeneric$dRep.$Sum(
                                                  "Inr",
                                                  Data$dGeneric$dRep.$Sum(
                                                    "Inr",
                                                    Data$dGeneric$dRep.$Sum(
                                                      "Inr",
                                                      Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                                                    )
                                                  )
                                                )
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "ForbiddenOrigin") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum(
                                                "Inr",
                                                Data$dGeneric$dRep.$Sum(
                                                  "Inr",
                                                  Data$dGeneric$dRep.$Sum(
                                                    "Inr",
                                                    Data$dGeneric$dRep.$Sum(
                                                      "Inr",
                                                      Data$dGeneric$dRep.$Sum(
                                                        "Inr",
                                                        Data$dGeneric$dRep.$Sum(
                                                          "Inr",
                                                          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))
                                                        )
                                                      )
                                                    )
                                                  )
                                                )
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "OriginNotProvided") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum(
                                                "Inr",
                                                Data$dGeneric$dRep.$Sum(
                                                  "Inr",
                                                  Data$dGeneric$dRep.$Sum(
                                                    "Inr",
                                                    Data$dGeneric$dRep.$Sum(
                                                      "Inr",
                                                      Data$dGeneric$dRep.$Sum(
                                                        "Inr",
                                                        Data$dGeneric$dRep.$Sum(
                                                          "Inr",
                                                          Data$dGeneric$dRep.$Sum(
                                                            "Inr",
                                                            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))
                                                          )
                                                        )
                                                      )
                                                    )
                                                  )
                                                )
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "PaymentError") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum(
                                                "Inr",
                                                Data$dGeneric$dRep.$Sum(
                                                  "Inr",
                                                  Data$dGeneric$dRep.$Sum(
                                                    "Inr",
                                                    Data$dGeneric$dRep.$Sum(
                                                      "Inr",
                                                      Data$dGeneric$dRep.$Sum(
                                                        "Inr",
                                                        Data$dGeneric$dRep.$Sum(
                                                          "Inr",
                                                          Data$dGeneric$dRep.$Sum(
                                                            "Inr",
                                                            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))
                                                          )
                                                        )
                                                      )
                                                    )
                                                  )
                                                )
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "InvalidPackagingAssignment") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum(
                                                "Inr",
                                                Data$dGeneric$dRep.$Sum(
                                                  "Inr",
                                                  Data$dGeneric$dRep.$Sum(
                                                    "Inr",
                                                    Data$dGeneric$dRep.$Sum(
                                                      "Inr",
                                                      Data$dGeneric$dRep.$Sum(
                                                        "Inr",
                                                        Data$dGeneric$dRep.$Sum(
                                                          "Inr",
                                                          Data$dGeneric$dRep.$Sum(
                                                            "Inr",
                                                            Data$dGeneric$dRep.$Sum(
                                                              "Inr",
                                                              Data$dGeneric$dRep.$Sum(
                                                                "Inr",
                                                                Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))
                                                              )
                                                            )
                                                          )
                                                        )
                                                      )
                                                    )
                                                  )
                                                )
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "SmsVerificationRequired") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum(
                                                "Inr",
                                                Data$dGeneric$dRep.$Sum(
                                                  "Inr",
                                                  Data$dGeneric$dRep.$Sum(
                                                    "Inr",
                                                    Data$dGeneric$dRep.$Sum(
                                                      "Inr",
                                                      Data$dGeneric$dRep.$Sum(
                                                        "Inr",
                                                        Data$dGeneric$dRep.$Sum(
                                                          "Inr",
                                                          Data$dGeneric$dRep.$Sum(
                                                            "Inr",
                                                            Data$dGeneric$dRep.$Sum(
                                                              "Inr",
                                                              Data$dGeneric$dRep.$Sum(
                                                                "Inr",
                                                                Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))
                                                              )
                                                            )
                                                          )
                                                        )
                                                      )
                                                    )
                                                  )
                                                )
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    $runtime.fail();
  }
};
const showCheckoutError = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "RestaurantDoesNotExist"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "AccountDoesNotExist"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "InvalidUserInSession"});
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "OrderDoesNotExist"});
    const $4 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "OrderNotEditable"});
    const $5 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "RegisteredUserShouldLogIn"});
    const $6 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "EmailNotProvidedAndNotLoggedIn"});
    const $7 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "InvalidEmail"});
    const $8 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "InvalidPhoneNumber"});
    const $9 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "QrWaiterDisabled"});
    const $10 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "FulfillmentMethodNotSupported"});
    const $11 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "PaymentMethodNotSupported"});
    const $12 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "InvalidVatId"});
    const $13 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "LocaleNotEnabled"});
    const $14 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "NotInDeliveryArea"});
    const $15 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "CoordinatesNotProvided"});
    const $16 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["actualValue", Data$dMoney$dRounded.toString(v.actualValue)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "currency",
            Restaumatic$dCurrencies.showCurrency.show(v.currency)
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["limit", Data$dMoney$dRounded.toString(v.limit)]))([])));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "OrderValueTooLow"});
    const $17 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["actualValue", Data$dMoney$dRounded.toString(v.actualValue)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "currency",
            Restaumatic$dCurrencies.showCurrency.show(v.currency)
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["limit", Data$dMoney$dRounded.toString(v.limit)]))([])));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "OrderValueTooHigh"});
    const $18 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "DelayedDeliveryNotEnabled"});
    const $19 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["difference", "(Seconds " + Data$dShow.showNumberImpl(v.difference) + ")"]))([]);
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "RequestedDeliveryTimeTooShort"});
    const $20 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "OutsideOfOrderingHours"});
    const $21 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "DelayedDeliveryOutsideOfOrderingHours"});
    const $22 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $22 = Data$dShow.showArrayImpl(Restaumatic$dValidation$dTypes.showError.show);
      return {genericShowArgs: v => [$22(v)]};
    })())({reflectSymbol: () => "PromotionValidationErrors"});
    const $23 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "InvalidCoupon"});
    const $24 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["groupIndex", Data$dShow.showIntImpl(v.groupIndex)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "itemError",
            showItemError.show(v.itemError)
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "name",
            (() => {
              if (v.name.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.name._1) + ")"; }
              if (v.name.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))([])));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "ItemError"});
    const $25 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "FodAlreadyOrderedToAddress"});
    const $26 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "ExtraDiscountNotAllowed"});
    const $27 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "ForbiddenOrigin"});
    const $28 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "OriginNotProvided"});
    const $29 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dOrders$dPayments$dTypes$dPaymentError.showError.show(v)]})({
      reflectSymbol: () => "PaymentError"
    });
    const $30 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "InvalidPackagingAssignment"});
    const $31 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "SmsVerificationRequired"});
    return x => {
      const $32 = genericCheckoutError.from(x);
      if ($32.tag === "Inl") { return $0["genericShow'"]($32._1); }
      if ($32.tag === "Inr") {
        if ($32._1.tag === "Inl") { return $1["genericShow'"]($32._1._1); }
        if ($32._1.tag === "Inr") {
          if ($32._1._1.tag === "Inl") { return $2["genericShow'"]($32._1._1._1); }
          if ($32._1._1.tag === "Inr") {
            if ($32._1._1._1.tag === "Inl") { return $3["genericShow'"]($32._1._1._1._1); }
            if ($32._1._1._1.tag === "Inr") {
              if ($32._1._1._1._1.tag === "Inl") { return $4["genericShow'"]($32._1._1._1._1._1); }
              if ($32._1._1._1._1.tag === "Inr") {
                if ($32._1._1._1._1._1.tag === "Inl") { return $5["genericShow'"]($32._1._1._1._1._1._1); }
                if ($32._1._1._1._1._1.tag === "Inr") {
                  if ($32._1._1._1._1._1._1.tag === "Inl") { return $6["genericShow'"]($32._1._1._1._1._1._1._1); }
                  if ($32._1._1._1._1._1._1.tag === "Inr") {
                    if ($32._1._1._1._1._1._1._1.tag === "Inl") { return $7["genericShow'"]($32._1._1._1._1._1._1._1._1); }
                    if ($32._1._1._1._1._1._1._1.tag === "Inr") {
                      if ($32._1._1._1._1._1._1._1._1.tag === "Inl") { return $8["genericShow'"]($32._1._1._1._1._1._1._1._1._1); }
                      if ($32._1._1._1._1._1._1._1._1.tag === "Inr") {
                        if ($32._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $9["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1); }
                        if ($32._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if ($32._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $10["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1); }
                          if ($32._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                            if ($32._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $11["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1); }
                            if ($32._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                              if ($32._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $12["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1._1); }
                              if ($32._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $13["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1); }
                                if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                  if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $14["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1); }
                                  if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                    if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                      return $15["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                    }
                                    if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                      if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                        return $16["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                      }
                                      if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                        if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                          return $17["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                        }
                                        if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                          if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                            return $18["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                          }
                                          if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                            if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                              return $19["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                            }
                                            if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                              if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                return $20["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                              }
                                              if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                  return $21["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                }
                                                if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                  if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                    return $22["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                  }
                                                  if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                    if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                      return $23["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                    }
                                                    if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                      if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                        return $24["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                      }
                                                      if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                        if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                          return $25["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                        }
                                                        if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                          if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                            return $26["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                          }
                                                          if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                            if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                              return $27["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                            }
                                                            if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                              if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                                return $28["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                              }
                                                              if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                                  return $29["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                }
                                                                if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                  if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                                    return $30["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                  }
                                                                  if ($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                    return $31["genericShow'"]($32._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                  }
                                                                  $runtime.fail();
                                                                }
                                                                $runtime.fail();
                                                              }
                                                              $runtime.fail();
                                                            }
                                                            $runtime.fail();
                                                          }
                                                          $runtime.fail();
                                                        }
                                                        $runtime.fail();
                                                      }
                                                      $runtime.fail();
                                                    }
                                                    $runtime.fail();
                                                  }
                                                  $runtime.fail();
                                                }
                                                $runtime.fail();
                                              }
                                              $runtime.fail();
                                            }
                                            $runtime.fail();
                                          }
                                          $runtime.fail();
                                        }
                                        $runtime.fail();
                                      }
                                      $runtime.fail();
                                    }
                                    $runtime.fail();
                                  }
                                  $runtime.fail();
                                }
                                $runtime.fail();
                              }
                              $runtime.fail();
                            }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeCheckoutError = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "RestaurantDoesNotExist"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "AccountDoesNotExist"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "InvalidUserInSession"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "OrderDoesNotExist"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "OrderNotEditable"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "RegisteredUserShouldLogIn"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "EmailNotProvidedAndNotLoggedIn"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({reflectSymbol: () => "InvalidEmail"}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "InvalidPhoneNumber"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "QrWaiterDisabled"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "FulfillmentMethodNotSupported"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "PaymentMethodNotSupported"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({reflectSymbol: () => "InvalidVatId"}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "LocaleNotEnabled"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "NotInDeliveryArea"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "CoordinatesNotProvided"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "OrderValueTooLow"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "actualValue"})(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons({
        reflectSymbol: () => "currency"
      })(Restaumatic$dCurrencies.unscrambleDecodeCurrency)(Unscramble.decodeRecordCons({reflectSymbol: () => "limit"})(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "OrderValueTooHigh"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "actualValue"})(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons({
        reflectSymbol: () => "currency"
      })(Restaumatic$dCurrencies.unscrambleDecodeCurrency)(Unscramble.decodeRecordCons({reflectSymbol: () => "limit"})(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "DelayedDeliveryNotEnabled"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "RequestedDeliveryTimeTooShort"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "difference"})(Data$dTime$dDuration$dSerialized.udecodeSeconds)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "OutsideOfOrderingHours"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "DelayedDeliveryOutsideOfOrderingHours"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "PromotionValidationErrors"})((() => {
      const $0 = Unscramble.decodeArray(Restaumatic$dValidation$dTypes.udecode.unsafeDecode);
      return {unsafeDecodeSingleConstructorArgument: x => $0(x.contents)};
    })()))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "InvalidCoupon"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "ItemError"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "groupIndex"})(Unscramble.decodeInt1)(Unscramble.decodeRecordCons({
        reflectSymbol: () => "itemError"
      })(unscrambleDecodeItemError)(Unscramble.decodeRecordCons({reflectSymbol: () => "name"})(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "FodAlreadyOrderedToAddress"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "ExtraDiscountNotAllowed"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "ForbiddenOrigin"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "OriginNotProvided"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "PaymentError"})({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dOrders$dPayments$dTypes$dPaymentError.unscrambleDecodeError.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "InvalidPackagingAssignment"
    }))(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({reflectSymbol: () => "SmsVerificationRequired"})))))))))))))))))))))))))))))))))(Unscramble$dGeneric.defaultOptions);
    return x => genericCheckoutError.to($0(x));
  })()
};
const encodeProductItem = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericProductItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ProductItem"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "quantity"
    })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "productKey"})({encodeWithOptions: v => Restaumatic$dCart$dProductKey.encodeProductKey.encode}))({
      reflectSymbol: () => "note"
    })({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeOrderSplit = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericOrderSplit)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "OrderSplit"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "items"})((() => {
      const $0 = Data$dFunctor.arrayMap(encodeProductItem.encode);
      return {encodeWithOptions: v => $0};
    })()))({reflectSymbol: () => "draft"})({encodeWithOptions: v => Restaumatic$dOrders$dTypes.encodeOrderDraft.encode});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeItemError = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericItemError)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "MenuItemDisabled"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "InvalidQuantity"})((() => {
      const $1 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "requestedQuantity"})({
        encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $1.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "CustomProductsNotAvailable"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "FatalError"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dCartToOrder.encodeFatalError.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $4 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "SoftError"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dCartToOrder.encodeSoftError.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    return {
      encodeOpts: opts => v => {
        if (v.tag === "Inl") {
          return $0.encodeOpts({
            sumEncoding: opts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: opts.unwrapSingleArguments,
            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
            fieldTransform: opts.fieldTransform
          })(v._1);
        }
        if (v.tag === "Inr") {
          if (v._1.tag === "Inl") {
            return $1.encodeOpts({
              sumEncoding: opts.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: opts.unwrapSingleArguments,
              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
              fieldTransform: opts.fieldTransform
            })(v._1._1);
          }
          if (v._1.tag === "Inr") {
            if (v._1._1.tag === "Inl") {
              return $2.encodeOpts({
                sumEncoding: opts.sumEncoding,
                unwrapSingleConstructors: false,
                unwrapSingleArguments: opts.unwrapSingleArguments,
                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                fieldTransform: opts.fieldTransform
              })(v._1._1._1);
            }
            if (v._1._1.tag === "Inr") {
              if (v._1._1._1.tag === "Inl") {
                return $3.encodeOpts({
                  sumEncoding: opts.sumEncoding,
                  unwrapSingleConstructors: false,
                  unwrapSingleArguments: opts.unwrapSingleArguments,
                  unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                  fieldTransform: opts.fieldTransform
                })(v._1._1._1._1);
              }
              if (v._1._1._1.tag === "Inr") {
                return $4.encodeOpts({
                  sumEncoding: opts.sumEncoding,
                  unwrapSingleConstructors: false,
                  unwrapSingleArguments: opts.unwrapSingleArguments,
                  unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                  fieldTransform: opts.fieldTransform
                })(v._1._1._1._1);
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const encodeFulfillmentMethod = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericFulfillmentMethod)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Delivery"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "deliveryAddress"
      })({encodeWithOptions: v => Restaumatic$dAddresses$dTypes$dDeliveryAddress.encodeDeliveryAddress.encode}))({reflectSymbol: () => "customDeliveryPrice"})({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return Data$dInt.toNumber(v2._1) / 100.0; }
          $runtime.fail();
        }
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Takeaway"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "DineIn"})((() => {
      const $2 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "location"})({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return Restaumatic$dOrders$dTypes$dFulfillmentMethod.encodeDineInLocation.encode(v2._1); }
          $runtime.fail();
        }
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $2.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "NoContactDelivery"})((() => {
      const $3 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "deliveryAddress"})({
        encodeWithOptions: v => Restaumatic$dAddresses$dTypes$dDeliveryAddress.encodeDeliveryAddress.encode
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $3.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    return {
      encodeOpts: opts => v => {
        if (v.tag === "Inl") {
          return $0.encodeOpts({
            sumEncoding: opts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: opts.unwrapSingleArguments,
            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
            fieldTransform: opts.fieldTransform
          })(v._1);
        }
        if (v.tag === "Inr") {
          if (v._1.tag === "Inl") {
            return $1.encodeOpts({
              sumEncoding: opts.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: opts.unwrapSingleArguments,
              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
              fieldTransform: opts.fieldTransform
            })(v._1._1);
          }
          if (v._1.tag === "Inr") {
            if (v._1._1.tag === "Inl") {
              return $2.encodeOpts({
                sumEncoding: opts.sumEncoding,
                unwrapSingleConstructors: false,
                unwrapSingleArguments: opts.unwrapSingleArguments,
                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                fieldTransform: opts.fieldTransform
              })(v._1._1._1);
            }
            if (v._1._1.tag === "Inr") {
              return $3.encodeOpts({
                sumEncoding: opts.sumEncoding,
                unwrapSingleConstructors: false,
                unwrapSingleArguments: opts.unwrapSingleArguments,
                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                fieldTransform: opts.fieldTransform
              })(v._1._1._1);
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const encodeCustomer = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCustomer)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Customer"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "subscribedRestaumatic"
    })({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "subscribed"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "subscribeRestaumaticPhone"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "subscribeRestaumaticEmail"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "subscribePhone"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "subscribeEmail"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "phone"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "fullName"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "email"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeCheckoutRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCheckoutRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "CheckoutRequest"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "waiterPin"
    })({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "vatId"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dVatId.encodeVatId.encode(v2._1); }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "userNote"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "restaurantId"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "requestedFulfillmentTime"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return DateUtils.formatISODateTime(v2._1); }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "promotionalItems"})((() => {
      const $0 = Data$dFunctor.arrayMap(Restaumatic$dPromotions$dTypes$dPromotionalItem.encodePromotionalItem.encode);
      return {encodeWithOptions: v => $0};
    })()))({reflectSymbol: () => "paymentMethod"})({encodeWithOptions: v => Restaumatic$dOrders$dTypes$dPaymentMethod.encodePaymentMethod.encode}))({
      reflectSymbol: () => "packagingContainers"
    })((() => {
      const $0 = Data$dFunctor.arrayMap(Data$dTuple$dT2.encodeT2({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
      })((() => {
        const $0 = Data$dFunctor.arrayMap(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.encodeContainedId.encode);
        return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", $0(v)), Data$dList$dTypes.Nil)};
      })()).encode);
      return {
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return $0(v2._1); }
          $runtime.fail();
        }
      };
    })()))({reflectSymbol: () => "origin"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dOrders$dTypes$dOrderOrigin.encodeOrderOrigin.encode(v2._1); }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "locale"})({encodeWithOptions: v => Restaumatic$dLocales.encodeLocale.encode}))({reflectSymbol: () => "items"})((() => {
      const $0 = Data$dFunctor.arrayMap(encodeProductItem.encode);
      return {encodeWithOptions: v => $0};
    })()))({reflectSymbol: () => "fulfillmentMethod"})({encodeWithOptions: v => encodeFulfillmentMethod.encode}))({reflectSymbol: () => "extraDiscount"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dOrders$dCheckout$dTypes$dExtraDiscount.encodeExtraDiscount.encode(v2._1); }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "draft"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dOrders$dTypes.encodeOrderDraft.encode(v2._1); }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "customer"})({encodeWithOptions: v => encodeCustomer.encode}))({reflectSymbol: () => "couponCodes"})((() => {
      const $0 = Data$dFunctor.arrayMap(Unsafe$dCoerce.unsafeCoerce);
      return {encodeWithOptions: v => $0};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeCheckoutError = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCheckoutError)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "RestaurantDoesNotExist"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "AccountDoesNotExist"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "InvalidUserInSession"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "OrderDoesNotExist"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $4 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "OrderNotEditable"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $5 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "RegisteredUserShouldLogIn"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $6 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "EmailNotProvidedAndNotLoggedIn"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $7 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "InvalidEmail"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $8 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "InvalidPhoneNumber"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $9 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "QrWaiterDisabled"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $10 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "FulfillmentMethodNotSupported"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $11 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "PaymentMethodNotSupported"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $12 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "InvalidVatId"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $13 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "LocaleNotEnabled"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $14 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "NotInDeliveryArea"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $15 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "CoordinatesNotProvided"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $16 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "OrderValueTooLow"})((() => {
      const $16 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "limit"
      })({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode}))({reflectSymbol: () => "currency"})({
        encodeWithOptions: v => Restaumatic$dCurrencies.encodeCurrency.encode
      }))({reflectSymbol: () => "actualValue"})({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $16.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $17 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "OrderValueTooHigh"})((() => {
      const $17 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "limit"
      })({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode}))({reflectSymbol: () => "currency"})({
        encodeWithOptions: v => Restaumatic$dCurrencies.encodeCurrency.encode
      }))({reflectSymbol: () => "actualValue"})({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $17.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $18 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "DelayedDeliveryNotEnabled"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $19 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "RequestedDeliveryTimeTooShort"})((() => {
      const $19 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "difference"})({
        encodeWithOptions: v => Data$dTime$dDuration$dSerialized.encodeSeconds.encode
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $19.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $20 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "OutsideOfOrderingHours"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $21 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "DelayedDeliveryOutsideOfOrderingHours"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $22 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "PromotionValidationErrors"})((() => {
      const $22 = Data$dFunctor.arrayMap(Restaumatic$dValidation$dTypes.encodeError.encode);
      return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", $22(v)), Data$dList$dTypes.Nil)};
    })());
    const $23 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "InvalidCoupon"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $24 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ItemError"})((() => {
      const $24 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "name"
      })({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return v2._1; }
          $runtime.fail();
        }
      }))({reflectSymbol: () => "itemError"})({encodeWithOptions: v => encodeItemError.encode}))({reflectSymbol: () => "groupIndex"})({
        encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $24.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $25 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "FodAlreadyOrderedToAddress"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $26 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ExtraDiscountNotAllowed"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $27 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ForbiddenOrigin"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $28 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "OriginNotProvided"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $29 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "PaymentError"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dOrders$dPayments$dTypes$dPaymentError.encodeError.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $30 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "InvalidPackagingAssignment"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $31 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "SmsVerificationRequired"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    return {
      encodeOpts: opts => v => {
        if (v.tag === "Inl") {
          return $0.encodeOpts({
            sumEncoding: opts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: opts.unwrapSingleArguments,
            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
            fieldTransform: opts.fieldTransform
          })(v._1);
        }
        if (v.tag === "Inr") {
          if (v._1.tag === "Inl") {
            return $1.encodeOpts({
              sumEncoding: opts.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: opts.unwrapSingleArguments,
              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
              fieldTransform: opts.fieldTransform
            })(v._1._1);
          }
          if (v._1.tag === "Inr") {
            if (v._1._1.tag === "Inl") {
              return $2.encodeOpts({
                sumEncoding: opts.sumEncoding,
                unwrapSingleConstructors: false,
                unwrapSingleArguments: opts.unwrapSingleArguments,
                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                fieldTransform: opts.fieldTransform
              })(v._1._1._1);
            }
            if (v._1._1.tag === "Inr") {
              if (v._1._1._1.tag === "Inl") {
                return $3.encodeOpts({
                  sumEncoding: opts.sumEncoding,
                  unwrapSingleConstructors: false,
                  unwrapSingleArguments: opts.unwrapSingleArguments,
                  unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                  fieldTransform: opts.fieldTransform
                })(v._1._1._1._1);
              }
              if (v._1._1._1.tag === "Inr") {
                if (v._1._1._1._1.tag === "Inl") {
                  return $4.encodeOpts({
                    sumEncoding: opts.sumEncoding,
                    unwrapSingleConstructors: false,
                    unwrapSingleArguments: opts.unwrapSingleArguments,
                    unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                    fieldTransform: opts.fieldTransform
                  })(v._1._1._1._1._1);
                }
                if (v._1._1._1._1.tag === "Inr") {
                  if (v._1._1._1._1._1.tag === "Inl") {
                    return $5.encodeOpts({
                      sumEncoding: opts.sumEncoding,
                      unwrapSingleConstructors: false,
                      unwrapSingleArguments: opts.unwrapSingleArguments,
                      unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                      fieldTransform: opts.fieldTransform
                    })(v._1._1._1._1._1._1);
                  }
                  if (v._1._1._1._1._1.tag === "Inr") {
                    if (v._1._1._1._1._1._1.tag === "Inl") {
                      return $6.encodeOpts({
                        sumEncoding: opts.sumEncoding,
                        unwrapSingleConstructors: false,
                        unwrapSingleArguments: opts.unwrapSingleArguments,
                        unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                        fieldTransform: opts.fieldTransform
                      })(v._1._1._1._1._1._1._1);
                    }
                    if (v._1._1._1._1._1._1.tag === "Inr") {
                      if (v._1._1._1._1._1._1._1.tag === "Inl") {
                        return $7.encodeOpts({
                          sumEncoding: opts.sumEncoding,
                          unwrapSingleConstructors: false,
                          unwrapSingleArguments: opts.unwrapSingleArguments,
                          unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                          fieldTransform: opts.fieldTransform
                        })(v._1._1._1._1._1._1._1._1);
                      }
                      if (v._1._1._1._1._1._1._1.tag === "Inr") {
                        if (v._1._1._1._1._1._1._1._1.tag === "Inl") {
                          return $8.encodeOpts({
                            sumEncoding: opts.sumEncoding,
                            unwrapSingleConstructors: false,
                            unwrapSingleArguments: opts.unwrapSingleArguments,
                            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                            fieldTransform: opts.fieldTransform
                          })(v._1._1._1._1._1._1._1._1._1);
                        }
                        if (v._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if (v._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                            return $9.encodeOpts({
                              sumEncoding: opts.sumEncoding,
                              unwrapSingleConstructors: false,
                              unwrapSingleArguments: opts.unwrapSingleArguments,
                              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                              fieldTransform: opts.fieldTransform
                            })(v._1._1._1._1._1._1._1._1._1._1);
                          }
                          if (v._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                            if (v._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                              return $10.encodeOpts({
                                sumEncoding: opts.sumEncoding,
                                unwrapSingleConstructors: false,
                                unwrapSingleArguments: opts.unwrapSingleArguments,
                                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                fieldTransform: opts.fieldTransform
                              })(v._1._1._1._1._1._1._1._1._1._1._1);
                            }
                            if (v._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                              if (v._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                return $11.encodeOpts({
                                  sumEncoding: opts.sumEncoding,
                                  unwrapSingleConstructors: false,
                                  unwrapSingleArguments: opts.unwrapSingleArguments,
                                  unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                  fieldTransform: opts.fieldTransform
                                })(v._1._1._1._1._1._1._1._1._1._1._1._1);
                              }
                              if (v._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                if (v._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                  return $12.encodeOpts({
                                    sumEncoding: opts.sumEncoding,
                                    unwrapSingleConstructors: false,
                                    unwrapSingleArguments: opts.unwrapSingleArguments,
                                    unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                    fieldTransform: opts.fieldTransform
                                  })(v._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                }
                                if (v._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                  if (v._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                    return $13.encodeOpts({
                                      sumEncoding: opts.sumEncoding,
                                      unwrapSingleConstructors: false,
                                      unwrapSingleArguments: opts.unwrapSingleArguments,
                                      unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                      fieldTransform: opts.fieldTransform
                                    })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                  }
                                  if (v._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                    if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                      return $14.encodeOpts({
                                        sumEncoding: opts.sumEncoding,
                                        unwrapSingleConstructors: false,
                                        unwrapSingleArguments: opts.unwrapSingleArguments,
                                        unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                        fieldTransform: opts.fieldTransform
                                      })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                    }
                                    if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                      if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                        return $15.encodeOpts({
                                          sumEncoding: opts.sumEncoding,
                                          unwrapSingleConstructors: false,
                                          unwrapSingleArguments: opts.unwrapSingleArguments,
                                          unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                          fieldTransform: opts.fieldTransform
                                        })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                      }
                                      if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                        if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                          return $16.encodeOpts({
                                            sumEncoding: opts.sumEncoding,
                                            unwrapSingleConstructors: false,
                                            unwrapSingleArguments: opts.unwrapSingleArguments,
                                            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                            fieldTransform: opts.fieldTransform
                                          })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                        }
                                        if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                          if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                            return $17.encodeOpts({
                                              sumEncoding: opts.sumEncoding,
                                              unwrapSingleConstructors: false,
                                              unwrapSingleArguments: opts.unwrapSingleArguments,
                                              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                              fieldTransform: opts.fieldTransform
                                            })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                          }
                                          if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                            if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                              return $18.encodeOpts({
                                                sumEncoding: opts.sumEncoding,
                                                unwrapSingleConstructors: false,
                                                unwrapSingleArguments: opts.unwrapSingleArguments,
                                                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                                fieldTransform: opts.fieldTransform
                                              })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                            }
                                            if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                              if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                return $19.encodeOpts({
                                                  sumEncoding: opts.sumEncoding,
                                                  unwrapSingleConstructors: false,
                                                  unwrapSingleArguments: opts.unwrapSingleArguments,
                                                  unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                                  fieldTransform: opts.fieldTransform
                                                })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                              }
                                              if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                  return $20.encodeOpts({
                                                    sumEncoding: opts.sumEncoding,
                                                    unwrapSingleConstructors: false,
                                                    unwrapSingleArguments: opts.unwrapSingleArguments,
                                                    unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                                    fieldTransform: opts.fieldTransform
                                                  })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                }
                                                if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                  if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                    return $21.encodeOpts({
                                                      sumEncoding: opts.sumEncoding,
                                                      unwrapSingleConstructors: false,
                                                      unwrapSingleArguments: opts.unwrapSingleArguments,
                                                      unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                                      fieldTransform: opts.fieldTransform
                                                    })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                  }
                                                  if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                    if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                      return $22.encodeOpts({
                                                        sumEncoding: opts.sumEncoding,
                                                        unwrapSingleConstructors: false,
                                                        unwrapSingleArguments: opts.unwrapSingleArguments,
                                                        unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                                        fieldTransform: opts.fieldTransform
                                                      })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                    }
                                                    if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                      if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                        return $23.encodeOpts({
                                                          sumEncoding: opts.sumEncoding,
                                                          unwrapSingleConstructors: false,
                                                          unwrapSingleArguments: opts.unwrapSingleArguments,
                                                          unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                                          fieldTransform: opts.fieldTransform
                                                        })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                      }
                                                      if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                        if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                          return $24.encodeOpts({
                                                            sumEncoding: opts.sumEncoding,
                                                            unwrapSingleConstructors: false,
                                                            unwrapSingleArguments: opts.unwrapSingleArguments,
                                                            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                                            fieldTransform: opts.fieldTransform
                                                          })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                        }
                                                        if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                          if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                            return $25.encodeOpts({
                                                              sumEncoding: opts.sumEncoding,
                                                              unwrapSingleConstructors: false,
                                                              unwrapSingleArguments: opts.unwrapSingleArguments,
                                                              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                                              fieldTransform: opts.fieldTransform
                                                            })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                          }
                                                          if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                            if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                              return $26.encodeOpts({
                                                                sumEncoding: opts.sumEncoding,
                                                                unwrapSingleConstructors: false,
                                                                unwrapSingleArguments: opts.unwrapSingleArguments,
                                                                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                                                fieldTransform: opts.fieldTransform
                                                              })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                            }
                                                            if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                              if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                                return $27.encodeOpts({
                                                                  sumEncoding: opts.sumEncoding,
                                                                  unwrapSingleConstructors: false,
                                                                  unwrapSingleArguments: opts.unwrapSingleArguments,
                                                                  unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                                                  fieldTransform: opts.fieldTransform
                                                                })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                              }
                                                              if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                                  return $28.encodeOpts({
                                                                    sumEncoding: opts.sumEncoding,
                                                                    unwrapSingleConstructors: false,
                                                                    unwrapSingleArguments: opts.unwrapSingleArguments,
                                                                    unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                                                    fieldTransform: opts.fieldTransform
                                                                  })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                }
                                                                if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                  if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                                    return $29.encodeOpts({
                                                                      sumEncoding: opts.sumEncoding,
                                                                      unwrapSingleConstructors: false,
                                                                      unwrapSingleArguments: opts.unwrapSingleArguments,
                                                                      unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                                                      fieldTransform: opts.fieldTransform
                                                                    })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                  }
                                                                  if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                    if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                                      return $30.encodeOpts({
                                                                        sumEncoding: opts.sumEncoding,
                                                                        unwrapSingleConstructors: false,
                                                                        unwrapSingleArguments: opts.unwrapSingleArguments,
                                                                        unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                                                        fieldTransform: opts.fieldTransform
                                                                      })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                    }
                                                                    if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                      return $31.encodeOpts({
                                                                        sumEncoding: opts.sumEncoding,
                                                                        unwrapSingleConstructors: false,
                                                                        unwrapSingleArguments: opts.unwrapSingleArguments,
                                                                        unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                                                        fieldTransform: opts.fieldTransform
                                                                      })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                    }
                                                                    $runtime.fail();
                                                                  }
                                                                  $runtime.fail();
                                                                }
                                                                $runtime.fail();
                                                              }
                                                              $runtime.fail();
                                                            }
                                                            $runtime.fail();
                                                          }
                                                          $runtime.fail();
                                                        }
                                                        $runtime.fail();
                                                      }
                                                      $runtime.fail();
                                                    }
                                                    $runtime.fail();
                                                  }
                                                  $runtime.fail();
                                                }
                                                $runtime.fail();
                                              }
                                              $runtime.fail();
                                            }
                                            $runtime.fail();
                                          }
                                          $runtime.fail();
                                        }
                                        $runtime.fail();
                                      }
                                      $runtime.fail();
                                    }
                                    $runtime.fail();
                                  }
                                  $runtime.fail();
                                }
                                $runtime.fail();
                              }
                              $runtime.fail();
                            }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const decodeProductItem = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericProductItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "ProductItem"})(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "quantity"
  })({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "productKey"})({
    decodeWithOptions: v => Restaumatic$dCart$dProductKey.decodeProductKey.decode
  })())({reflectSymbol: () => "note"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeOrderSplit = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericOrderSplit)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "OrderSplit"})(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "items"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(decodeProductItem);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "draft"})({decodeWithOptions: v => Restaumatic$dOrders$dTypes.decodeOrderDraft.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeItemError = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericItemError)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "MenuItemDisabled"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "InvalidQuantity"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "requestedQuantity"
  })({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "CustomProductsNotAvailable"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "FatalError"
  })({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dCartToOrder.decodeFatalError.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "SoftError"})({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dCartToOrder.decodeSoftError.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))))))
};
const decodeFulfillmentMethod = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericFulfillmentMethod)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "Delivery"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "deliveryAddress"
  })({decodeWithOptions: v => Restaumatic$dAddresses$dTypes$dDeliveryAddress.decodeDeliveryAddress.decode})())({reflectSymbol: () => "customDeliveryPrice"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dMoney$dRounded.decodeMoney.decode)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "Takeaway"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "DineIn"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "location"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dOrders$dTypes$dFulfillmentMethod.decodeDineInLocation.decode)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "NoContactDelivery"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "deliveryAddress"
  })({decodeWithOptions: v => Restaumatic$dAddresses$dTypes$dDeliveryAddress.decodeDeliveryAddress.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument)))))
};
const decodeCustomer = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCustomer)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "Customer"})(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "subscribedRestaumatic"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readBoolean(Data$dIdentity.monadIdentity))})())({reflectSymbol: () => "subscribed"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readBoolean(Data$dIdentity.monadIdentity))
  })())({reflectSymbol: () => "subscribeRestaumaticPhone"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readBoolean(Data$dIdentity.monadIdentity))
  })())({reflectSymbol: () => "subscribeRestaumaticEmail"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readBoolean(Data$dIdentity.monadIdentity))
  })())({reflectSymbol: () => "subscribePhone"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readBoolean(Data$dIdentity.monadIdentity))})())({
    reflectSymbol: () => "subscribeEmail"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readBoolean(Data$dIdentity.monadIdentity))})())({reflectSymbol: () => "phone"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))
  })())({reflectSymbol: () => "fullName"})({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "email"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeCheckoutRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCheckoutRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "CheckoutRequest"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "waiterPin"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readInt(Data$dIdentity.monadIdentity))})())({reflectSymbol: () => "vatId"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dVatId.decodeVatId.decode)
  })())({reflectSymbol: () => "userNote"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())({
    reflectSymbol: () => "restaurantId"
  })({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "requestedFulfillmentTime"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dUTCTime.decodeUTCTime.decode)
  })())({reflectSymbol: () => "promotionalItems"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dPromotions$dTypes$dPromotionalItem.decodePromotionalItem);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "paymentMethod"})({decodeWithOptions: v => Restaumatic$dOrders$dTypes$dPaymentMethod.decodePaymentMethod.decode})())({
    reflectSymbol: () => "packagingContainers"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.arrayDecode(Data$dTuple$dT2.decodeT2({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    })((() => {
      const $0 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.decodeContainedId);
      return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
    })())).decode);
    return {decodeWithOptions: v => $0};
  })())())({reflectSymbol: () => "origin"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dOrders$dTypes$dOrderOrigin.decodeOrderOrigin.decode)})())({
    reflectSymbol: () => "locale"
  })({decodeWithOptions: v => Restaumatic$dLocales.decodeLocale.decode})())({reflectSymbol: () => "items"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(decodeProductItem);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "fulfillmentMethod"})({decodeWithOptions: v => decodeFulfillmentMethod.decode})())({reflectSymbol: () => "extraDiscount"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dOrders$dCheckout$dTypes$dExtraDiscount.decodeExtraDiscount.decode)
  })())({reflectSymbol: () => "draft"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dOrders$dTypes.decodeOrderDraft.decode)})())({
    reflectSymbol: () => "customer"
  })({decodeWithOptions: v => decodeCustomer.decode})())({reflectSymbol: () => "couponCodes"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Foreign$dGeneric$dClass.stringDecode);
    return {decodeWithOptions: v => $0.decode};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeCheckoutError = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCheckoutError)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "RestaurantDoesNotExist"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "AccountDoesNotExist"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "InvalidUserInSession"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "OrderDoesNotExist"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "OrderNotEditable"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "RegisteredUserShouldLogIn"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "EmailNotProvidedAndNotLoggedIn"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "InvalidEmail"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "InvalidPhoneNumber"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "QrWaiterDisabled"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "FulfillmentMethodNotSupported"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "PaymentMethodNotSupported"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "InvalidVatId"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "LocaleNotEnabled"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "NotInDeliveryArea"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "CoordinatesNotProvided"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "OrderValueTooLow"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "limit"
  })({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode})())({reflectSymbol: () => "currency"})({
    decodeWithOptions: v => Restaumatic$dCurrencies.decodeCurrency.decode
  })())({reflectSymbol: () => "actualValue"})({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "OrderValueTooHigh"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "limit"
  })({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode})())({reflectSymbol: () => "currency"})({
    decodeWithOptions: v => Restaumatic$dCurrencies.decodeCurrency.decode
  })())({reflectSymbol: () => "actualValue"})({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "DelayedDeliveryNotEnabled"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "RequestedDeliveryTimeTooShort"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "difference"
  })({decodeWithOptions: v => Data$dTime$dDuration$dSerialized.decodeSeconds.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "OutsideOfOrderingHours"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "DelayedDeliveryOutsideOfOrderingHours"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "PromotionValidationErrors"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dValidation$dTypes.decodeError);
    return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
  })())(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "InvalidCoupon"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ItemError"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "name"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())({reflectSymbol: () => "itemError"})({
    decodeWithOptions: v => decodeItemError.decode
  })())({reflectSymbol: () => "groupIndex"})({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "FodAlreadyOrderedToAddress"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ExtraDiscountNotAllowed"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ForbiddenOrigin"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "OriginNotProvided"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "PaymentError"
  })({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dOrders$dPayments$dTypes$dPaymentError.decodeError.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "InvalidPackagingAssignment"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "SmsVerificationRequired"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments)))))))))))))))))))))))))))))))))
};
export {
  $CheckoutError,
  $FulfillmentMethod,
  $ItemError,
  AccountDoesNotExist,
  CheckoutRequest,
  CoordinatesNotProvided,
  CustomProductsNotAvailable,
  Customer,
  DelayedDeliveryNotEnabled,
  DelayedDeliveryOutsideOfOrderingHours,
  Delivery,
  DineIn,
  EmailNotProvidedAndNotLoggedIn,
  ExtraDiscountNotAllowed,
  FatalError,
  FodAlreadyOrderedToAddress,
  ForbiddenOrigin,
  FulfillmentMethodNotSupported,
  InvalidCoupon,
  InvalidEmail,
  InvalidPackagingAssignment,
  InvalidPhoneNumber,
  InvalidQuantity,
  InvalidUserInSession,
  InvalidVatId,
  ItemError,
  LocaleNotEnabled,
  MenuItemDisabled,
  NoContactDelivery,
  NotInDeliveryArea,
  OrderDoesNotExist,
  OrderNotEditable,
  OrderSplit,
  OrderValueTooHigh,
  OrderValueTooLow,
  OriginNotProvided,
  OutsideOfOrderingHours,
  PaymentError,
  PaymentMethodNotSupported,
  ProductItem,
  PromotionValidationErrors,
  QrWaiterDisabled,
  RegisteredUserShouldLogIn,
  RequestedDeliveryTimeTooShort,
  RestaurantDoesNotExist,
  SmsVerificationRequired,
  SoftError,
  Takeaway,
  decodeCheckoutError,
  decodeCheckoutRequest,
  decodeCustomer,
  decodeFulfillmentMethod,
  decodeItemError,
  decodeOrderSplit,
  decodeProductItem,
  encodeCheckoutError,
  encodeCheckoutRequest,
  encodeCustomer,
  encodeFulfillmentMethod,
  encodeItemError,
  encodeOrderSplit,
  encodeProductItem,
  eqCheckoutError,
  eqCheckoutRequest,
  eqCustomer,
  eqFulfillmentMethod,
  eqItemError,
  eqOrderSplit,
  eqProductItem,
  genericCheckoutError,
  genericCheckoutRequest,
  genericCustomer,
  genericFulfillmentMethod,
  genericItemError,
  genericOrderSplit,
  genericProductItem,
  hasFieldCheckoutRequest,
  hasFieldCustomer,
  hasFieldOrderSplit,
  hasFieldProductItem,
  newtypeCheckoutRequest_,
  newtypeCustomer_,
  newtypeOrderSplit_,
  newtypeProductItem_,
  showCheckoutError,
  showCheckoutRequest,
  showCustomer,
  showFulfillmentMethod,
  showItemError,
  showOrderSplit,
  showProductItem,
  unscrambleDecodeCheckoutError,
  unscrambleDecodeCheckoutRequest,
  unscrambleDecodeCustomer,
  unscrambleDecodeFulfillmentMethod,
  unscrambleDecodeItemError,
  unscrambleDecodeOrderSplit,
  unscrambleDecodeProductItem
};
